module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "row d-flex align-items-center",
    attrs: {
      "id": "header"
    }
  }, [_c('div', {
    class: _vm.$store.state.customerInfo ? 'col-lg-5 col-md-12' : 'col-lg-8 col-md-12'
  }, [_vm._m(0)]), _vm._v(" "), _c('div', {
    staticClass: "col col-lg-1 col-md-12 item item-1 text-lg-right"
  }, [_c('nobr', [_c('i', {
    staticClass: "fa-solid fa-at",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" "), _c('a', {
    attrs: {
      "href": "http://www.rychlydrat.cz/kontakt",
      "title": "",
      "target": "_blank"
    }
  }, [_vm._v("Napište nám")])])], 1), _vm._v(" "), _c('div', {
    staticClass: "col col-lg-3 col-md-12 item item-2 text-lg-right"
  }, [_c('nobr', [_c('i', {
    staticClass: "fa-solid fa-headset",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" "), _c('a', {
    attrs: {
      "href": "tel:+420212244400"
    }
  }, [_vm._v("+420 212 244 400")])])], 1), _vm._v(" "), (_vm.$store.state.customerInfo) ? _c('div', {
    staticClass: "col-lg-3 col-md-12 item item-3 d-flex",
    attrs: {
      "id": "customer-info"
    }
  }, [_c('i', {
    staticClass: "fa-solid fa-user",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v("\n       \n      "), _c('span', [_c('div', [_vm._v(_vm._s(_vm.human_readable_name(_vm.$store.state.customerInfo)))]), _vm._v(" "), _c('div', [_vm._v(_vm._s(_vm.human_readable_address(_vm.$store.state.customerInfo)))]), _vm._v(" "), _c('div', [_c('abbr', {
    attrs: {
      "title": "variabilní symbol pro platby"
    }
  }, [_vm._v("VS")]), _vm._v(" " + _vm._s(_vm.$store.state.customerInfo.id) + "\n          "), _c('br'), _vm._v(" "), _c('router-link', {
    attrs: {
      "to": "/logout",
      "title": ""
    }
  }, [_vm._v("odhlásit")])], 1)])]) : _vm._e()])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('a', {
    attrs: {
      "href": "https://www.rychlydrat.cz/"
    }
  }, [_c('img', {
    attrs: {
      "src": "/static/rd-images/logo.png",
      "alt": "Rychlý drát",
      "id": "logo",
      "height": "90"
    }
  })])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-fa5d21de","hasScoped":true}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Header.vue
// module id = 332
// module chunks = 1 2